export default {
	service: [
		"Servicio",
		"Evento",
		"Retiro",
		"Depósito",
		"Términos y Condiciones",
		"Certificado",
		"FAQs",
		"Guía del Usuario",
		"VIP"
	],
	sign: {
		title: "Conectado durante {0} día",
		SignIn: "Iniciar sesión"
	},
	hotMusicAlbum: "Álbum de Música Caliente",
	hotMusic: "Listas de Canciones Calientes",
	popular: "Reproducción Nueva",
	rankings: "Películas populares",
	top: "TOP{0}",
	OnchainServices: "Servicios Onchain",
	Real: {
		title: "En tiempo real",
		list: [
			"Usuarios Totales en Línea",
			"Volumen Promedio de Optimización por Usuario",
			"Mapa de Calor de Necesidades de Optimización",
			"Cantidad de Optimización de Promoción de la Plataforma"
		]
	},
	work: {
		title: "Recompensa por envío de pedidos",
		SignIn: "Obtener"
	},
	Profit: {
		Profit: "Beneficio",
		tabs: ["Beneficio", "Bono", "Cuenta"],
		TotalBalance: "Saldo Total",
		TotalLuckyBonus: "Bono de Suerte Total",
		todayEarnings: "Ganancias de Hoy",
		availableBalance: "Saldo Disponible",
		title: ["Ganancias de Hoy", "Ganancias Totales", "Cuenta"],
		list: ["Ganancias por Pedido", "Ganancias del Equipo", "Ganancias Totales"],
		order: {
			title: "Beneficio por Pedido",
			commission: "Comisión por Pedido"
		},
		Analysis: {
			title: "Análisis de Beneficios",
			tips: "Has realizado {0} transacciones",
			tabs: ["Beneficio de Hoy", "Beneficio Total"],
			totalTitle: ["Beneficio por Pedido", "Beneficio por Registro", "Beneficio del Equipo", "Beneficio por Bono"]
		}
	},
	CustomerService: {
		title: "Centro de Servicio al Cliente",
		consultation: "Consulta de Servicio al Cliente",
		btn: "Contáctenos",
		noticeTitle: "Notificación del Sistema"
	},
	addWallet: "Añadir billetera",
	taskProgress: "Progreso de tareas diarias",
	currentProgress: "Progreso actual de la tarea",
	awardsBulletin: `{0} usuario gana {1} {2} premio en la tarea.`,
	vip: {
		title: "@:vip.title",
		more: "Ver más"
	},
	stats: {
		title: "Fuentes de datos - Panel de control y API",
		subTitle: "Estadísticas de artistas",
		list: ["Métricas", "Artistas con redes sociales activas", "Actualizadas diariamente"]
	}
};
